import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

export default function LocationDesignSection({
  editedSection,
  t,
  flags,
  onStyleChange,
}) {
  if (!flags?.isLocationSection) return null;

  const style = editedSection?.style || {};

  return (
    <>
      <EditorGroup
        title={t("sectionModal.location.cards.title", "Location Cards")}
        subtitle={t(
          "sectionModal.location.cards.help",
          "Control card, panel, text and icon colors for the location section"
        )}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t("sectionModal.location.cardBg", "Card Background")}
            type="color"
            value={style.locationCardBg}
            onChange={(v) => onStyleChange("locationCardBg", v)}
          />
          <Field
            label={t("sectionModal.location.cardBorder", "Card Border")}
            type="color"
            value={style.locationCardBorder}
            onChange={(v) => onStyleChange("locationCardBorder", v)}
          />
          <Field
            label={t("sectionModal.location.panelBg", "Inner Panel Background")}
            type="color"
            value={style.locationPanelBg}
            onChange={(v) => onStyleChange("locationPanelBg", v)}
          />
          <Field
            label={t("sectionModal.location.panelBorder", "Inner Panel Border")}
            type="color"
            value={style.locationPanelBorder}
            onChange={(v) => onStyleChange("locationPanelBorder", v)}
          />
          <Field
            label={t("sectionModal.location.nameColor", "Location Name Color")}
            type="color"
            value={style.locationNameColor}
            onChange={(v) => onStyleChange("locationNameColor", v)}
          />
          <Field
            label={t("sectionModal.location.textColor", "Main Text Color")}
            type="color"
            value={style.locationTextColor}
            onChange={(v) => onStyleChange("locationTextColor", v)}
          />
          <Field
            label={t("sectionModal.location.mutedTextColor", "Muted Text Color")}
            type="color"
            value={style.locationMutedTextColor}
            onChange={(v) => onStyleChange("locationMutedTextColor", v)}
          />
          <Field
            label={t("sectionModal.location.iconColor", "Icon Color")}
            type="color"
            value={style.locationIconColor}
            onChange={(v) => onStyleChange("locationIconColor", v)}
          />
        </div>
      </EditorGroup>

      <EditorGroup
        title={t("sectionModal.location.badges.title", "Badges and Tags")}
        subtitle={t(
          "sectionModal.location.badges.help",
          "Colors for highlights, pills and today status"
        )}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t("sectionModal.location.badgeBg", "Badge Background")}
            type="color"
            value={style.locationBadgeBg}
            onChange={(v) => onStyleChange("locationBadgeBg", v)}
          />
          <Field
            label={t("sectionModal.location.badgeText", "Badge Text")}
            type="color"
            value={style.locationBadgeTextColor}
            onChange={(v) => onStyleChange("locationBadgeTextColor", v)}
          />
          <Field
            label={t("sectionModal.location.badgeBorder", "Badge Border")}
            type="color"
            value={style.locationBadgeBorder}
            onChange={(v) => onStyleChange("locationBadgeBorder", v)}
          />
          <Field
            label={t("sectionModal.location.todayBg", "Today Box Background")}
            type="color"
            value={style.locationTodayBg}
            onChange={(v) => onStyleChange("locationTodayBg", v)}
          />
          <Field
            label={t("sectionModal.location.todayText", "Today Box Text")}
            type="color"
            value={style.locationTodayText}
            onChange={(v) => onStyleChange("locationTodayText", v)}
          />
          <Field
            label={t("sectionModal.location.imageOverlay", "Image Overlay")}
            type="color"
            value={style.locationImageOverlayColor}
            onChange={(v) => onStyleChange("locationImageOverlayColor", v)}
          />
        </div>
      </EditorGroup>

      <EditorGroup
        title={t("sectionModal.location.mapTabs.title", "Map Tabs")}
        subtitle={t(
          "sectionModal.location.mapTabs.help",
          "Colors for map and street view tabs"
        )}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t("sectionModal.location.mapTabActiveBg", "Active Tab Background")}
            type="color"
            value={style.locationMapTabActiveBg}
            onChange={(v) => onStyleChange("locationMapTabActiveBg", v)}
          />
          <Field
            label={t("sectionModal.location.mapTabActiveText", "Active Tab Text")}
            type="color"
            value={style.locationMapTabActiveText}
            onChange={(v) => onStyleChange("locationMapTabActiveText", v)}
          />
          <Field
            label={t("sectionModal.location.mapTabInactiveBg", "Inactive Tab Background")}
            type="color"
            value={style.locationMapTabInactiveBg}
            onChange={(v) => onStyleChange("locationMapTabInactiveBg", v)}
          />
          <Field
            label={t("sectionModal.location.mapTabInactiveText", "Inactive Tab Text")}
            type="color"
            value={style.locationMapTabInactiveText}
            onChange={(v) => onStyleChange("locationMapTabInactiveText", v)}
          />
          <Field
            label={t("sectionModal.location.mapTabBorder", "Tab Border")}
            type="color"
            value={style.locationMapTabBorder}
            onChange={(v) => onStyleChange("locationMapTabBorder", v)}
          />
        </div>
      </EditorGroup>
    </>
  );
}